import { InjectionToken } from '@angular/core';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
import { CommonsModalService } from 'ib-web-commons/dist/app/core/ib-modal/services/ib-modal-service';
export const AJSGiftCardsCommonsModalService = new InjectionToken('CommonsModalService');
export const AJSGiftCardsCommonsModalServiceProvider = upgradeAJSServiceProvider('CommonsModalService', AJSGiftCardsCommonsModalService);
export interface GiftCardsCommonsModalServiceType extends CommonsModalService {
    showLoginErrorModal(errorObject, isModalBlocked, template, extraModalClass),
    showLoginModal(template, modelObject, animationEnabled, clss),
    showFilterModal(template, modelObject, animationEnabled, clss, controller, controllerAs),
    openInsuranceModal(modelObject, tpl),
    showITravelWarningModal(modelObject), showGenericDynamicModal(isModalBlocked, template, modelObject, controller),
    showBKIGenericModal(isModalBlocked, template, modelObject, extraModalClass),
    
    showBKISliceTimeLeftModal(timeLeft)

    showWaitingModal(template, classTpl, background, modelObject?);
    finishWaiting();
    closeAllCurrentModals();
    showGenericModal (isModalBlocked, template, modelObject, extraModalClass);
    openBuildGenericModal (
        dataModel: object,
        template: string,
        extraModalClass: string,
        nameController: string,
        isModalBlocked?: boolean
    );
    showGenericError(
        errorObject,
        isModalBlocked,
        extraModalClass
    );
}
